import axios from 'axios';
import _ from 'lodash';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
const BASE = BaseModel.getApiBasePath() + '/api/v1/urbiotica/tech-infos';

export default new class UrbioticaTechMessagesModel {

  constructor() { }

  get(id) {
    return new Promise((resolve, reject) => {
      this.getAll()
        .then((data) => {
          resolve(_.find(data, { id: id }));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getLastMsgs(id) {
    var filter = {
      order: 'stamps DESC',
      limit: 2
    };
    if (id) {
      filter = _.merge(filter, { where: { and: [{ infrastructureID: id }, { or: [{ phenomenonID: 'temperature' }, { phenomenonID: 'node_battery' }] }] } });
    }
    return new Promise((resolve, reject) => {
      axios.get(BASE, {
        params: {
          access_token: UserModel.getAccessToken(),
          filter: filter
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getAll(dateFrom = null, dateTo = null) {
    var filter = {
      order: 'stamps DESC'
    };
    if (dateFrom && dateTo) {
      filter = _.merge(filter, { where: { and: [{ stamps: { gte: dateFrom } }, { stamps: { lte: dateTo } }] } });
    }
    return new Promise((resolve, reject) => {
      axios.get(BASE, {
        params: {
          access_token: UserModel.getAccessToken(),
          filter: filter
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  create(data) {
    return new Promise((resolve, reject) => {
      axios.post(BASE, data, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  remove(id) {
    return new Promise((resolve, reject) => {
      axios.delete(BASE + '/' + id, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

}


// WEBPACK FOOTER //
// ./src/components/UrbioticaTechMessagesModel.js